<script setup lang="ts">
// types
import type { StrapiFooter } from '@ts-strapi/interfaces'
// components
import FooterColumn from '@Widgets/Footers/FooterColumn.vue'
import FooterSocials from '@Widgets/Footers/FooterSocials.vue'
import FooterBadgeGrid from '@Widgets/Footers/FooterBadgeGrid.vue'
import FooterBottomRow from '@Widgets/Footers/FooterBottomRow.vue'

defineOptions({
  name: 'FooterMobile',
})

defineProps<{
  data: StrapiFooter
}>()
</script>

<template>
  <footer class="footer-mobile">
    <div class="footer-mobile__columns">
      <FooterColumn
        v-for="col in data.columns"
        :key="col.title"
        :column="col"
      />
    </div>

    <div class="footer-mobile__aside">
      <FooterBadgeGrid
        v-if="data.paymentBadges.length"
        :items="data.paymentBadges"
        variant="payment"
      />
      <FooterBadgeGrid
        v-if="data.trustBadges.length"
        :items="data.trustBadges"
        variant="trust"
      />
      <FooterSocials
        v-if="data.socials.length"
        :label="data.followUsLabel"
        :items="data.socials"
      />
    </div>

    <FooterBottomRow
      :items="data.bottomItems"
      variant="mobile"
    />
  </footer>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Footers/FooterMobile.scss" />
